import { render, staticRenderFns } from "./TelefonoNavar.vue?vue&type=template&id=3fefa8ba&scoped=true"
import script from "./TelefonoNavar.vue?vue&type=script&lang=js"
export * from "./TelefonoNavar.vue?vue&type=script&lang=js"
import style0 from "./TelefonoNavar.vue?vue&type=style&index=0&id=3fefa8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fefa8ba",
  null
  
)

export default component.exports